const fieldValue = (form, name) => form.elements.namedItem(name).value.trim();

const endpointValue = (form, name) => {
    const value        = fieldValue(form, name);
    const defaultPorts = form.querySelector('[data-default-ports]');

    if (value !== '' || defaultPorts?.dataset.defaultPortInput !== name) {
        return value;
    }

    return String(JSON.parse(defaultPorts.dataset.defaultPorts)[defaultPorts.querySelector('select').value]);
};

const hasChangedEndpoint = (form, button) => Object
    .entries(JSON.parse(button.dataset.connectionTestSavedEndpoint))
    .some(([name, savedValue]) => endpointValue(form, name) !== String(savedValue));

const hasEnteredPassword = form => form.elements.namedItem('password').value !== '';

const isComplete = button => {
    const form = document.getElementById(button.dataset.connectionTestForm);

    const hasRequiredFields = button.dataset.connectionTestRequires
        .split(' ')
        .every(name => (name === 'password' ? hasEnteredPassword(form) : fieldValue(form, name) !== ''));

    if (!hasRequiredFields) {
        return false;
    }

    if (button.dataset.connectionTestSavedEndpoint === undefined) {
        return true;
    }

    return hasEnteredPassword(form) || !hasChangedEndpoint(form, button);
};

const syncButton = button => {
    button.disabled = !isComplete(button);
};

const testButtonOf = form => document.querySelector(`[data-connection-test-form="${CSS.escape(form.id)}"]`);

const needsPassingTest = form => {
    const identity   = form.elements.namedItem('serverIdentity');
    const testButton = testButtonOf(form);

    if (!identity || !testButton || identity.value !== '') {
        return false;
    }

    return testButton.dataset.connectionTestSavedEndpoint === undefined || hasChangedEndpoint(form, testButton);
};

const syncSubmitButtonsOf = form => {
    const disabled = needsPassingTest(form);

    document
        .querySelectorAll(`button[type="submit"][form="${CSS.escape(form.id)}"]`)
        .forEach(button => {
            button.disabled = disabled;
        });
};

const syncButtonsOf = form => {
    document.querySelectorAll(`[data-connection-test-form="${CSS.escape(form.id)}"]`).forEach(syncButton);
    syncSubmitButtonsOf(form);
};

export const syncConnectionTestButtons = root => {
    root.querySelectorAll('[data-connection-test-form]').forEach(syncButton);

    const forms = root instanceof HTMLFormElement ? [root] : root.querySelectorAll('form[id]');

    forms.forEach(syncButtonsOf);
};

const ENDPOINT_FIELDS = ['protocol', 'host', 'port'];

const forgetTestedIdentity = form => {
    const identity = form.elements.namedItem('serverIdentity');

    if (identity) {
        identity.value = '';
    }
};

export const handleConnectionTestInput = target => {
    if (!target.form?.id) {
        return;
    }

    if (ENDPOINT_FIELDS.includes(target.name)) {
        forgetTestedIdentity(target.form);
    }

    syncButtonsOf(target.form);
};

export const trustTestedIdentity = button => {
    const form = document.getElementById(
        button.closest('.connection-test').querySelector('[data-connection-test-form]').dataset.connectionTestForm,
    );

    form.elements.namedItem('serverIdentity').value = button.dataset.trustTestedIdentity;

    button.closest('.connection-test-trust').replaceChildren(button.nextElementSibling);
    syncButtonsOf(form);
};
